module.exports = __webpack_public_path__ + "img/mult2.d128b001.svg";